import { Link, Modal, Stack, TextContainer } from '@shopify/polaris';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

const MarketingGuideModal = (props: any) => {
  const [guideStep, setGuideStep] = useState(0);
  const [shop, setShop] = useState({ id: '', url: '' });
  const history = useHistory();

  useEffect(() => {
    let shop = JSON.parse(localStorage.getItem('shop') || '{}');
    if (shop && shop.id) {
      setShop(shop);
    }
  }, []);

  useEffect(() => {
    props.setGuideStep(guideStep);
  }, [guideStep]);

  const modalContentGuideStep = () => {
    switch (guideStep) {
      case 0:
        return (
          <TextContainer>
            <b>What is a WhatsApp marketing campaign?</b>
            <p>
              WhatsApp marketing campaigns are one of the most popular marketing
              strategies that allow sending of promotional messages, product
              releases, newsletters & much more to users via WhatsApp in bulk.
              It’s a hassle-free way of delivering business updates to customers
              on a day-to-day basis.
            </p>
            <p>
              E.g. product-related insights, latest arrivals, delivery updates,
              newsletter subscriptions, and more.
            </p>
          </TextContainer>
        );

      case 1:
        return (
          <span>
            <TextContainer>
              <p>
                You can view previously created campaigns and create new ones in
                the “Marketing Campaigns” page which can be opened via a listing
                under “WhatsApp” in the left navigation drawer.
              </p>
              <br></br>
              <div style={{ width: '100%', height: '100%' }}>
                <img
                  style={{
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    display: 'block',
                  }}
                  className=''
                  src='https://cdn.shopify.com/s/files/1/0449/7794/6790/files/screenshot-qa-wa-ss-integration.gupshup.io-2022.08.16-12_28_31.png?v=1660636124'
                  alt='Form Options'
                />
              </div>
            </TextContainer>
          </span>
        );

      case 2:
        return (
          <TextContainer>
            <p>
              On the “Marketing Campaigns” page click the “Create New Campaign”
              button to create a new campaign.
            </p>
            <div style={{ width: '100%', height: '100%' }}>
              <img
                style={{
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  display: 'block',
                  width: '80%',
                }}
                src='https://cdn.shopify.com/s/files/1/0449/7794/6790/files/create_campaign.png?v=1661235458'
                alt='Checkout Page Checkbox'
              />
            </div>
            <p>
              Enter the “Campaign Name” and click the “Select Template” button
            </p>
            <img
              style={{
                marginLeft: 'auto',
                marginRight: 'auto',
                display: 'block',
              }}
              src='https://cdn.shopify.com/s/files/1/0449/7794/6790/files/image_116.png?v=1657869796'
              alt='Checkout Page Checkbox'
            />
            <p>
              Choose an approved template {" "}
              <span
                onClick={() => {
                  history.push({ pathname: '/campaigns', state: { tab: 'ct' }});
                }}
                style={{color:'blue',cursor:"default"}}
              >
                (You can create a new template here)
              </span>
            </p>
            <div style={{ width: '100%', height: '100%' }}>
              <img
                style={{
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  display: 'block',
                }}
                src='https://cdn.shopify.com/s/files/1/0449/7794/6790/files/image_117.png?v=1657869796'
                alt='Checkout Page Checkbox'
              />
            </div>
          </TextContainer>
        );

      // case 3:
      //   return (
      //     <TextContainer>
      //       <p>
      //         <b>Attachments (optional)</b>

      //         <p>
      //           Based on the selected message template, the name and content of
      //           the message will be displayed. In case your message has an
      //           attachment, enter a public URL for the media in the following
      //           format:
      //         </p>
      //         <ul>
      //           <li>
      //             Image: Supported media type: jpeg and png with a maximum file
      //             size of 5MB
      //           </li>
      //           <li>
      //             Video: Supported media type: mp4 and 3gpp with a maximum file
      //             size of 16MB
      //           </li>
      //           <li>
      //             Audio: Supported media type: aac, amr, mpeg and mp4 with a
      //             maximum file size of 16MB
      //           </li>
      //           <li>
      //             Document: Supported media type: Any valid MIME-type with a
      //             maximum file size of 100MB
      //           </li>
      //         </ul>
      //       </p>
      //       <div style={{ width: '100%', height: '100%' }}>
      //         <img
      //           style={{
      //             marginLeft: 'auto',
      //             marginRight: 'auto',
      //             display: 'block',
      //           }}
      //           src='https://cdn.shopify.com/s/files/1/0449/7794/6790/files/image_118.png?v=1657869796'
      //           alt='Consent Page Url Option'
      //         />
      //       </div>
      //       <br />
      //     </TextContainer>
      //   );

      case 3:
        return (
          <TextContainer>
            <p>
              Based on your message, you can see the numbers in the double curly
              brackets such as {'{{1}}'}, {'{{2}}'}, {'{{3}}'} and so on in
              dynamic values. These dynamic values are the personalization
              parameters for each user which you need to enter along with the
              list of contacts.
            </p>
            <div style={{ width: '100%', height: '100%' }}>
              <img
                style={{
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  display: 'block',
                }}
                src='https://cdn.shopify.com/s/files/1/0449/7794/6790/files/image_119.png?v=1657869796'
                alt='Form Options'
              />
            </div>
            <p>
              Download a sample sheet by clicking on the “Get Sample” button
            </p>
            <div style={{ width: '100%', height: '100%' }}>
              <img
                style={{
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  display: 'block',
                }}
                src='https://cdn.shopify.com/s/files/1/0449/7794/6790/files/image_120.png?v=1657869796'
                alt='Form Options'
              />
            </div>
            <p>
              For example, we want to send the following message to 100
              contacts:
            </p>

            <p>Hi {'{{1}}'},</p>
            <p>
              We are offering up to 30% discount on all the apparel at our
              store. Come and grab the offer quickly.
            </p>

            <p>Here we have 1 variable parameter.</p>

            <div>
              We will first download the sample sheet and enter the contact
              numbers and values for the variable
              <span
                onClick={() => {
                  history.push({ pathname: '/optins'});
                }}
                style={{color:'blue',cursor:"default"}}
              >
                (Learn how to get the list of customers here)
              </span>
            </div>
            <div style={{ width: '100%', height: '100%' }}>
              <img
                style={{
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  display: 'block',
                  width:"50%"
                }}
                src='https://cdn.shopify.com/s/files/1/0449/7794/6790/files/image_121.png?v=1657869796'
                alt='Form Options'
              />
            </div>
            <p>
              If your selected template has dynamic variable
            </p>
            <div style={{ width: '100%', height: '100%' }}>
              <img
                style={{
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  display: 'block',
                  width:"80%"
                }}
                src='https://cdn.shopify.com/s/files/1/0449/7794/6790/files/btncta.png?v=1661239721'
                alt='Form Options'
              />
            </div>
            <p>
              then in the column with a title "Button URL suffix" enter the variable to append the suffix in the url
            </p>
            <div style={{ width: '100%', height: '100%' }}>
              <img
                style={{
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  display: 'block',
                  width:"60%"
                }}
                src='https://cdn.shopify.com/s/files/1/0449/7794/6790/files/image_144.png?v=1661236075'
                alt='Form Options'
              />
            </div>
            <p>
              <strong>Example: </strong>
              If your template had a dynamic variable : https://superlemon.xyz/{'{{1}}'}. And you want to put "order_status" in 'suffix' column to make it "https://superlemon.xyz/order_status</p>
          </TextContainer>
        );

      case 4:
        return (
          <span>
            <TextContainer>
              <b>Almost created!</b>
              <br />
              <p>
                Finally, proof read the whole campaign for mistakes or errors
                before clicking the “Submit” button. Once submitted, your
                message will be sent to all the uploaded contacts.
              </p>
              <div style={{ width: '100%', height: '100%' }}>
                <img
                  style={{
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    display: 'block',
                  }}
                  src='https://cdn.shopify.com/s/files/1/0449/7794/6790/files/image_122.png?v=1657870379'
                  alt='Accept sms checkbox label'
                />
              </div>
              <p>Happy Marketing!</p>
            </TextContainer>
          </span>
        );
    }
  };

  const incrementGuideStep = () => {
    setGuideStep(guideStep + 1);
  };

  const decrementGuideStep = () => {
    setGuideStep(guideStep - 1);
  };

  const stepsCompletedActions = () => {
    props.stepsCompleted();
    props.closeModal();
  };

  return (
    <Modal
      open={props.open}
      onClose={props.closeModal}
      // {modalTitleButtonContent}
      title={guideStep === 4 ? 'Marketing Campaign' : 'Marketing Campaign'}
      primaryAction={{
        content: guideStep === 4 ? 'Guide Completed' : 'Next step',
        onAction: guideStep === 4 ? stepsCompletedActions : incrementGuideStep,
      }}
      secondaryActions={
        guideStep >= 1
          ? [
              {
                content: 'Back',
                onAction: decrementGuideStep,
              },
            ]
          : undefined
      }
    >
      <Modal.Section>
        <Stack vertical>
          <Stack.Item>{modalContentGuideStep()}</Stack.Item>
        </Stack>
      </Modal.Section>
    </Modal>
  );
};
export default MarketingGuideModal;
